import type { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { PageLoader } from '@knitknot/shared/components/ui/page-loader';

import { useEntitlements } from '@/hooks/api/useEntitlements';
import { useWorkspaceStore } from '@/hooks/state';
import { consoleRoutes } from '@/lib/routes';

export function AgentPublishGate({ children }: { children: ReactNode }) {
  const workspaceId = useWorkspaceStore((state) => state.workspaceId);
  const { agentMirrorEnabled, isLoading } = useEntitlements(workspaceId);
  if (isLoading) return <PageLoader />;
  if (!agentMirrorEnabled) return <Navigate replace to={consoleRoutes.publish.pages} />;
  return children;
}

export function PublishIndexRoute() {
  const [searchParams] = useSearchParams();
  const legacyTab = searchParams.get('tab');
  const target =
    legacyTab === 'coverage'
      ? consoleRoutes.publish.coverage
      : legacyTab === 'vocabulary'
        ? consoleRoutes.data.vocabulary
        : legacyTab === 'claims'
          ? consoleRoutes.data.answerClaims
          : legacyTab === 'pages'
            ? consoleRoutes.publish.pages
            : consoleRoutes.publish.pages;
  const remaining = new URLSearchParams(searchParams);
  remaining.delete('tab');
  const query = remaining.toString();
  return <Navigate replace to={query ? `${target}?${query}` : target} />;
}
